import { createContext, useEffect, useState, useContext, useRef, useCallback, useMemo } from 'react';
import DataSource from 'devextreme/data/data_source';
import TaskItemTemplate from './pane-right-tasks-item-template';
import './pane-right-tasks.scss'
import TaskHeader from './pane-right-tasks-header';
import { ReadContext } from '../context/read-context';
import { TasksContext } from '../context/tasks-context';
import ArrayStore from 'devextreme/data/array_store';
import { CompleteContext } from '../context/complete-context';
import DataGrid, { Pager, Paging } from 'devextreme-react/data-grid';
import { Column } from 'devextreme-react/data-grid';
import { Selection } from 'devextreme-react/data-grid';

export default function PaneTasks({ color, handleTaskDescription }) {

    const [isCompact, setIsCompact] = useState(localStorage.getItem('isCompact') === 'true')

    const [read, setRead] = useContext(ReadContext);
    const [complete, setComplete] = useContext(CompleteContext);
    const [tasks, setTasks] = useContext(TasksContext);
    const [tasksPaginate, setTasksPaginate] = useState([]);

    const [paginate, setPaginate] = useState({ skip: 0, take: 20, searchValue: '' });
    const grdTasks = useRef(null);
    const [isSelectAll, setIsSelectAll] = useState(false);

    const isFuture = (task) => {
        return task.dateFrom && new Date(task.dateFrom) > new Date();
    }

    useEffect(() => {

        let result = [];

        if (!tasks)
            return;

        result = [...tasks];

        if (color) {

            if (color == 1 || color == 2 || color == 3)
                result = tasks.filter(a => a.color == color && !isFuture(a));
            else if (color == 5) {
                result = tasks.filter(a => isFuture(a));
            }
            else {
                result = tasks.filter(a => (!a.color || (a.color != 1 && a.color != 2 && a.color != 3)) && !isFuture(a));
            }

            if (!result.length) {
                setTasksPaginate(result);
                return;
            }
        }
        else {
            result = tasks.filter(a => !isFuture(a));
        }


        if (paginate.searchValue) {
            result = tasks.filter(a => a.text.toLowerCase().includes(paginate.searchValue.toLowerCase()));

            if (!result.length) {
                setTasksPaginate(result);
                return;
            }
        }


        // result = result.slice(paginate.skip, paginate.skip + paginate.take);
        if (result && result.length) {
            let notReadIDs = result.filter(a => !a.isRead).map(a => a.id);

            if (notReadIDs)
                setRead(notReadIDs);
        }
        setTasksPaginate(result);
    }, [tasks, paginate, color]);


    useEffect(() => {
        if (!complete || !complete.length)
            return;

        let store = grdTasks.current.instance.getDataSource().store();
        let storeChanges = [];

        for (var i = 0; i < complete.length; i++) {
            storeChanges.push({ type: "remove", key: complete[i].id });
        }

        store.push(storeChanges);
        //grdTasks.current.instance

    }, [complete]);

    const tasksDataSource = new DataSource({

        reshapeOnPush: false,
        paginate: false,
        pageSize: 20,

        store: new ArrayStore({
            key: 'id',
            data: tasksPaginate,
        }),
    });

    const handleSelectAll = useCallback((value) => {

        const rows = grdTasks.current.instance.getVisibleRows();

        if (rows && rows.length) {

            const ids = rows.map(row => row.data.id);

            if (value) {
                grdTasks.current.instance.selectRows(ids);
                setIsSelectAll(true);
            }
            else{
                grdTasks.current.instance.deselectRows(ids);
                setIsSelectAll(false);
            }
        }


    }, []);

    const handleSearch = useCallback((value) => {
        setPaginate({ skip: paginate.skip, take: paginate.take, searchValue: value });
    });

    const handleCompact = (e) => {
        setIsCompact(e);
    };

    const handleSelectionChanged = useCallback((e) => {

        let elem = document.getElementById("btnCompleteTask");

        if (!elem)
            return;

        if (e.selectedRowKeys && e.selectedRowKeys.length) {
            elem.classList.add("btnCompleteSelected");
        }
        else {
            elem.classList.remove("btnCompleteSelected");
        }
    }, []);

    const handleComplete = () => {

        const selectedRowsData = grdTasks.current.instance.getSelectedRowsData();

        if (selectedRowsData && selectedRowsData.length) {

            const selectedRowsDataWithComplete = selectedRowsData.filter(data => (data.commands.length && data.commands.some(command => command.isCompleteCommand)));

            if (selectedRowsDataWithComplete && selectedRowsDataWithComplete.length) {
                setComplete(selectedRowsDataWithComplete.map(item => ({ id: item.id, isPostComplete: true })));
                setIsSelectAll(false);
            }
        }
    };

    const handleFocusedRowChanged = useCallback((e) => {

        if (!e || !e.row || !e.row || !e.row.data)
            return;

        setTimeout(() => {

            if (!grdTasks.current.instance.getSelectedRowKeys().length) {
                var offset = grdTasks.current.instance.getController("data").getRowIndexOffset();
                var absoluteRowIndex = e.row.rowIndex + offset;

                grdTasks.current.instance.selectRowsByIndexes([absoluteRowIndex]);
                handleTaskDescription(e.row.data.id);
            }

        }, 500)
    });

    const handleRowClick = useCallback((row) => {

        if (!row || row.rowType != "data" || !row.data)
            return;

        handleTaskDescription(row.data.id);

    });

    // useEffect(() => {

    //     if (!task || task.isComplete)
    //         return;

    //     if (task.isTask) {

    //         // let dataSource = lstTasks.current.instance.getDataSource()

    //         // let items = dataSource.items();

    //         // if (items.some(a => a.id == task.id))
    //         //     return;

    //         // let store = dataSource.store();

    //         // store.push([{ type: "insert", data: task, index: items.length }]);
    //     }


    // }, [task]);


    return (

        <div className="list-tasks-container">

            <TaskHeader
                handleSelectAll={handleSelectAll}
                handleSearch={handleSearch}
                handleCompact={handleCompact}
                handleComplete={handleComplete}
                isSelectAll={isSelectAll}
            ></TaskHeader>

            <div className="list-tasks">

                <DataGrid
                    ref={grdTasks}

                    className="dxListTasks"
                    showColumnHeaders={false}
                    dataSource={tasksDataSource}
                    focusedRowEnabled={true}
                    onFocusedRowChanged={handleFocusedRowChanged}
                    hoverStateEnabled={true}
                    onSelectionChanged={handleSelectionChanged}
                    onRowClick={handleRowClick}
                    autoNavigateToFocusedRow={true}


                >
                    <Selection mode="multiple" />
                    <Column dataField="textFormatted" visible={!isCompact} cellRender={(task) => { return TaskItemTemplate(task.data, isCompact) }} />
                    <Column dataField="textCompact" visible={isCompact} cellRender={(task) => { return TaskItemTemplate(task.data, isCompact) }} />

                    <Paging defaultPageSize={20} />
                    <Pager
                        visible={true}
                        allowedPageSizes={[5, 10, 20, "all"]}
                        displayMode="full"
                        showPageSizeSelector={true}
                        showInfo={true}
                        showNavigationButtons={true} />
                </DataGrid>

            </div>
        </div>
    );
}



